import Vue from "vue";
import axios from "axios";

// set axios base URL
if (process.env.NODE_ENV == "production") axios.defaults.baseURL = "";
else axios.defaults.baseURL = "https://devchat.inn";
axios.defaults.headers.get["Accept"] = "application/json";

Vue.prototype.$http = axios;

const token = localStorage.getItem("token");
if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}
